import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-bone py-20" aria-labelledby="guarantee-title" data-id="element-94" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-95" data-mp="223eltma3nb3z">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-court-600" data-id="element-96" data-mp="222n2paxov5ul">
          ✔ Riesgo cero
        </p>
        <h2 id="guarantee-title" className="mt-4 flex items-center justify-center gap-3 font-display text-3xl font-black tracking-tight text-court-950 sm:text-4xl" data-id="element-97" data-mp="1x2im7kws6b4d">
          <ShieldCheckIcon className="h-8 w-8 shrink-0" aria-hidden="true" data-id="element-98" data-mp="14dteh317z7jn" />
          Garantía de 7 Días
        </h2>
        <p className="mt-8 text-lg leading-relaxed text-court-800" data-id="element-99" data-mp="1ee3tmt6tep1g">
          Abre todo. Revisa cada volumen. Usa los ejercicios en la cancha.
        </p>
        <p className="mt-4 text-lg leading-relaxed text-court-700" data-id="element-100" data-mp="qmonsqftxplg">
          Si Tenis 360 no transforma por completo la forma en que planificas y das tus sesiones, te
          devolvemos hasta el último centavo.
        </p>
        <p className="mt-8 inline-block rounded-full border border-court-950/15 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-court-950" data-id="element-101" data-mp="oxp0bxefwwy9">
          Sin preguntas · Tasa de reembolso menor al 2%
        </p>
      </div>
    </section>;
}